import React, { useState } from "react";
import './Login.css';
import { Card, Form, Button, InputGroup, Col, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromPath = location.state?.from || "/landing-page";
  console.log("fromPath", fromPath);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (fromPath === "/landing-page") {
        localStorage.setItem("isLoggedIn", "false");
        // Login using static credentials for EcommerceBot
        const staticUsername = "cqubeAdmin@gmail.com";
        // const staticPassword = "cqube@123";
        
        const response = await axios.post("https://cqube.sstus.net/login", {
          username: staticUsername,
          password,
        });
        
        if (response.data.token) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("isLoggedIn", "true");
          navigate("/EcommerceBot");
        } else {
          localStorage.setItem("isLoggedIn", "false");
          localStorage.setItem("token", "");
          setError("Login failed. Please try again.");
        }
      } else {
        // Default login behavior with email and password
        if (!email || !validateEmail(email)) {
          setError("Invalid email format or empty field.");
          return;
        }
        if (!password) {
          setError("Password is required.");
          return;
        }
        
        if (password === "SSTAI2024!") {
          localStorage.setItem("isLoggedIn", "true");
          navigate(fromPath);
        } else {
          setError("Incorrect Email or Password");
        }
      }
    } catch (error) {
      console.error("Login error", error);
      setError("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <Row className="justify-content-center">
        <Col lg={6} md={8} sm={12}>
          <Card className="p-4 shadow">
            <Card.Body>
              <Card.Title className="text-center">Log In</Card.Title>
              <Form onSubmit={handleLogin}>
                {fromPath === "/landing-page" ? (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </Form.Group>
                  </>
                ) : (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <InputGroup.Text onClick={() => setShowPassword(!showPassword)}>
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                {error && <p className="text-danger">{error}</p>}
                <Button variant="primary" type="submit" className="w-100">
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
